
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0","y":"0","viewBox":"0 0 20 20","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10","cy":"10","r":"9.3","fill":"#fbf7ef","stroke":"#ddd5c4"}}),_c('defs',[_c('path',{attrs:{"id":"SVGID_1_","d":"M4.7 3.4H17v12.3H4.7z"}})]),_c('clipPath',{attrs:{"id":"SVGID_00000158022352730060364210000013151694895838701240_"}},[_c('use',{attrs:{"xlink:href":"#SVGID_1_","overflow":"visible"}})]),_c('g',{attrs:{"clip-path":"url(#SVGID_00000158022352730060364210000013151694895838701240_)"}},[_c('path',{attrs:{"d":"M4.9 11.3c0-2.2 1.5-3.8 3.6-3.8 1.7 0 3.1.9 3.1 2 0 .5-.3.8-.8.9h-.1c-1.4 0-1.1-2.1-2.5-2.1-.8 0-1.5.6-1.5 2 0 2 1.2 3.2 2.7 3.2.7.1 1.3-.3 1.6-.9.2-.2.3-.3.4-.3s.3.1.3.4c-.1 1.2-1.1 2.6-3.1 2.6-2.2-.2-3.7-1.8-3.7-4z","fill":"#325a50"}}),_c('path',{attrs:{"d":"M13.9 4.1c-1.7-.1-3.1 1.1-3.3 2.7v.5s0 .1.1.1l.1.1c.7.2 1.2.8 1.3 1.6v.5c0 .1.1.1.1.1.5.3 1 .4 1.6.4s1.1-.2 1.6-.5.8-.7 1.1-1.2c.2-.5.4-1 .3-1.6-.2-1.4-1.4-2.6-2.9-2.7zm1.5 3.2c0 .1-.1.2-.2.2H14v1.2c0 .1-.1.2-.2.2h-.3c-.1 0-.2-.1-.2-.2V7.4h-1.2c-.1 0-.2 0-.2-.1V7c0-.1.1-.2.2-.2h1.2V5.7c0-.1.1-.2.2-.2h.3c.1 0 .2 0 .2.2v1.2h1.2c.1 0 .2.1.2.2v.2z","fill":"#e18264"}})])])
          )
        }
      }
    